<template>
  <section id="hero-block" v-bind:class="[classArray]" v-if="categoryInfo">
    <h2 class="title">{{categoryInfo.titulo}}</h2>
    <div class="row xsmall-collapse">
      <div class="xxlarge-5 xxlarge-offset-1 medium-6 medium-offset-0 small-12 columns">
        <img class="planta planta-q22" src="/static/imgs/quarto22.svg" alt="Planta do Quarto 22">
        <img class="planta planta-lab-cura" src="/static/imgs/lab-cura.svg" alt="Planta do Laboratório de Curadoria">
        <h3>{{categoryInfo.subtitle}}</h3>
      </div>
      <div class="xxlarge-4 xxlarge-offset-1 medium-6 medium-offset-0 small-12 columns">
        <h4>{{categoryInfo.description}}</h4>
      </div>
    </div>
    <span class="bg"></span>
  </section>
</template>

<script>
export default {
  name: 'hero-block',
  data: function () {
     return {
       value: [],
       classArray: [],
     }
  },
  beforeMount () {
    this.classArray = [this.$route.params.slug]
  },
  computed: {
    categoryInfo() {
      return this.$store.getters.getRoom(this.$route.params.slug);
    }
  },
  watch: {
    '$route' (to, from) {
      this.classArray = [this.$route.params.slug]
    }
  }
}
</script>
<!-- styling for the component -->
<style lang="scss">

#hero-block {
  position: relative;
  padding: 170px 0 85px 0;
  color: #000000;

  .bg {
    position: absolute;
    top: 0;
    left: 40px;
    width: calc(100% - 80px);
    height: 100%;
    pointer-events: none;
    z-index: -1;
  }

  .planta {
    max-width: 80%;
    display: none;
    margin-bottom: 50px;
  }

  &.quarto-22 {
    .bg {
      background-color: #fdd224;
    }
    .planta-q22 {
      display: block;
    }
  }

  &.laboratorio-de-curadoria {
    .bg {
      background-color: #66d6be;
    }
    .planta-lab-cura {
      display: block;
    }
  }

  &.galerias {
    .bg {
      background-color: $galerias;
    }
  }

  h2 {
    position: absolute;
    top: -0.62em;
    line-height: 1.1;
    left: 0;
    right: 0;
    width: 60%;
    margin: 0 auto;

    text-align: center;

    @include responsive-font-size(125px);
  }

  h3 {
    @include responsive-font-size(40px);
    color: #ffffff;
    line-height: 1.4;
    letter-spacing: -1px;
  }
  h4 {
    position: relative;
    @include responsive-font-size(16px);
    line-height: 1.8;
    letter-spacing: -0.25px;
  }
}

@include max-screen($small) {
  #hero-block {
    h3 {
      margin-bottom: 40px;
    }

    h2 {
      width: 100%;
      padding: 0 30px;
    }

    .bg {
      left: 30px;
      width: calc(100% - 60px);
    }

    .planta {
      max-width: 60%;
      margin: 50px auto;
    }
  }
}

@include max-screen($xsmall) {
  #hero-block {
    h3 {
      margin-bottom: 30px;
    }

    .bg {
      left: 20px;
      width: calc(100% - 40px);
    }

    .planta {
      max-width: 100%;
      margin: 0px auto 50px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/blocks/heroBlock.vue